var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":"","color":"transparent","height":"100%"}},[_c('v-card-text',[_c('v-content',[_c('Cards'),(_vm.userAccount.id)?_c('iframe',{staticStyle:{"height":"0"},attrs:{"src":_vm.urlConnection}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }